"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var confirm_1 = tslib_1.__importStar(require("./confirm"));
var Modal_1 = tslib_1.__importStar(require("./Modal"));
require("./style");
function modalWarn(props) {
    return (0, confirm_1.default)((0, confirm_1.withWarn)(props));
}
var Modal = Modal_1.default;
Modal.info = function infoFn(props) {
    return (0, confirm_1.default)((0, confirm_1.withInfo)(props));
};
Modal.success = function successFn(props) {
    return (0, confirm_1.default)((0, confirm_1.withSuccess)(props));
};
Modal.delete = function errorFn(props) {
    return (0, confirm_1.default)((0, confirm_1.withDelete)(props));
};
Modal.error = function errorFn(props) {
    return (0, confirm_1.default)((0, confirm_1.withError)(props));
};
Modal.warning = modalWarn;
Modal.warn = modalWarn;
Modal.confirm = function confirmFn(props) {
    return (0, confirm_1.default)((0, confirm_1.withConfirm)(props));
};
Modal.destroyAll = function destroyAllFn() {
    while (Modal_1.destroyFns.length) {
        var close_1 = Modal_1.destroyFns.pop();
        if (close_1) {
            close_1();
        }
    }
};
Modal.config = confirm_1.globalConfig;
exports.default = Modal;
//# sourceMappingURL=index.js.map